import React, { useState } from "react";
import FormattedMessage from "components/FormattedMessage";
import { Button, Box, Flex } from "ui-components";
import PageHeader from "components/PageHeader";
import Spinner, { styles } from "components/Spinner";
import DateOfBirthField from "components/FormFields/DateOfBirthField";
import TextField from "components/FormFields/TextField";
import PageFaqs from "components/PageFaqs";
import GuestOrder from "components/GuestOrder";
import OTPModal from "components/OTPModal";
import { urlParam, gotoUrl } from "utils/helpers";
import get from "lodash/get";
import { buttonThemes, getButtonColorVariant } from "ui-components/theme";
import ShowRecaptcha from "components/Recaptcha/ShowRecaptcha";

const OrderLoginCard = props => {
  const {
    formValues,
    invalid,
    isFetchingOrder,
    isFetchingOrderDetails,
    handleSubmit,
    fetchGuestOrder,
    order,
    minimumAge,
    dateOptions,
    monthOptions,
    yearOptions,
    appSettings,
    themeColors,
    locale,
    change,
    dateOfBirthFieldOrder
  } = props;

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const urlOrderRef = urlParam("order_ref");
  const buttonTheme = get(themeColors, "button") || buttonThemes.blue;
  const hideManageOrderDOB =
    get(appSettings, "generic.manage_order_ignore_dob") || false;
  const submit = () => {
    const enableOTP = get(appSettings, "generic.manage_order_otp");
    enableOTP ? setShowModal(true) : fetchGuestOrder(formValues);
    const orderOrPhone = get(formValues, "orderRefOrPhoneNumber");
    urlOrderRef &&
      urlOrderRef !== orderOrPhone &&
      gotoUrl(window.location.pathname, true, { order_ref: orderOrPhone });
  };

  const onOTPSubmitSuccess = sessionToken => {
    fetchGuestOrder({ ...formValues, sessionToken });
  };

  if (isFetchingOrder || isFetchingOrderDetails)
    return <Spinner size={200} sx={styles.fullPage} />;

  if (order) {
    return (
      <GuestOrder
        {...props}
        {...order}
        orderOrPhone={get(formValues, "orderRefOrPhoneNumber", "")}
        dob={hideManageOrderDOB ? "hidden" : get(formValues, "dob", "")}
        buttonTheme={buttonTheme}
        formValues={formValues}
        locale={locale}
      />
    );
  }

  const dobTooltip = get(locale, "manage_order_dob_tooltip");
  const orderRefTooltip = get(locale, "manage_order_order_ref_tooltip");
  const faqs = get(appSettings, "manage_order.faqs") || {};

  return (
    <>
      <ShowRecaptcha />
      <Box variant="main" padding="2rem">
        <form onSubmit={handleSubmit(submit)}>
          <PageHeader
            title="manage_order_text_1"
            subtitle="manage_order_text_2"
          />

          {!hideManageOrderDOB && (
            <DateOfBirthField
              required
              label="manage_order_date_of_birth"
              minimumAge={minimumAge}
              dateOptions={dateOptions}
              monthOptions={monthOptions}
              yearOptions={yearOptions}
              change={change}
              tooltip={dobTooltip}
              fieldOrder={dateOfBirthFieldOrder}
            />
          )}

          <TextField
            required
            tooltip={orderRefTooltip}
            field="orderRefOrPhoneNumber"
            label="manage_order_order_ref_or_circles_phone_number"
            placeholder="manage_order_order_ref_or_circles_phone_number_placeholder"
          />

          <Flex justifyContent="center">
            <Button disabled={invalid} sx={getButtonColorVariant(buttonTheme)}>
              <FormattedMessage id="login" />
            </Button>
            <OTPModal
              orderOrPhone={get(formValues, "orderRefOrPhoneNumber", "")}
              dob={hideManageOrderDOB ? "hidden" : get(formValues, "dob", "")}
              orderActionName={"manage_order"}
              showModal={showModal}
              closeModal={closeModal}
              buttonTheme={buttonTheme}
              onSuccess={onOTPSubmitSuccess}
              appSettings={appSettings}
            />
          </Flex>
        </form>
      </Box>
      <PageFaqs {...faqs} />
    </>
  );
};

OrderLoginCard.defaultProps = {
  items: "-",
  orderRef: "-",
  deliveryAddress: "",
  deliveryDate: "",
  handleSubmit: () => {}
};

export default OrderLoginCard;
